import React, { useEffect } from 'react';

import { Profile } from 'Deer/pages/Profile';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';

const AllReportsProfile = () => {
  const dispatch = useDispatch();

  //   this is needed to populate the L2 with people's data
  useEffect(() => {
    dispatch(setSelectedView({ id: -3 }));
    return () => {
      dispatch(setSelectedView({}));
    };
  }, []);

  return <Profile />;
};

export default AllReportsProfile;
